import { Link } from 'react-router-dom'

type ActiveLink = 'catalogo' | 'repuestos'

interface AppCatalogFooterProps {
  activeLink?: ActiveLink
}

export function AppCatalogFooter({ activeLink }: AppCatalogFooterProps) {
  return (
    <footer className="mt-auto border-t border-gray-200/60 bg-white/80 backdrop-blur-sm">
      <div className="px-4 py-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center justify-between gap-3 sm:flex-row sm:gap-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2.5 text-sm text-gray-600 transition-colors hover:text-[#1F2240] shrink-0"
          >
            <img src="/logo.png" alt="Oriental Ramirez" className="h-7 w-7 rounded-full object-cover ring-1 ring-gray-200" />
            <span className="font-semibold text-[#1F2240]">Oriental Ramirez</span>
          </Link>
          <div className="flex flex-wrap items-center justify-center gap-1 text-xs sm:text-sm">
            <Link
              to="/catalogo"
              className={`rounded-full px-3 py-1 transition-colors ${
                activeLink === 'catalogo'
                  ? 'bg-[#1F2240] text-white font-medium'
                  : 'text-gray-500 hover:text-[#1F2240] hover:bg-gray-100'
              }`}
            >
              Catálogo
            </Link>
            <Link
              to="/repuestos"
              className={`rounded-full px-3 py-1 transition-colors ${
                activeLink === 'repuestos'
                  ? 'bg-[#1F2240] text-white font-medium'
                  : 'text-gray-500 hover:text-[#1F2240] hover:bg-gray-100'
              }`}
            >
              Repuestos
            </Link>
            <Link to="/sucursales" className="rounded-full px-3 py-1 text-gray-500 transition-colors hover:text-[#1F2240] hover:bg-gray-100">
              Sucursales
            </Link>
            <Link to="/financiamiento" className="rounded-full px-3 py-1 text-gray-500 transition-colors hover:text-[#1F2240] hover:bg-gray-100">
              Financiamiento
            </Link>
          </div>
          <p className="text-[11px] text-gray-400 shrink-0">
            © {new Date().getFullYear()} Todos los derechos reservados
          </p>
        </div>
      </div>
    </footer>
  )
}
